import { render, staticRenderFns } from "./login-configuration.vue?vue&type=template&id=1293a23e&scoped=true&"
import script from "./login-configuration.vue?vue&type=script&lang=js&"
export * from "./login-configuration.vue?vue&type=script&lang=js&"
import style0 from "./login-configuration.vue?vue&type=style&index=0&id=1293a23e&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293a23e",
  null
  
)

export default component.exports